export const ABOUT_LIST_FETCH = 'ABOUT_LIST_FETCH';
export const ABOUT_LIST_SUCCESS = 'ABOUT_LIST_SUCCESS';
export const ABOUT_LIST_FAILURE = 'ABOUT_LIST_FAILURE';

export const DELETE_ABOUT_FETCH = 'DELETE_ABOUT_FETCH';
export const DELETE_ABOUT_SUCCESS = 'DELETE_ABOUT_SUCCESS';
export const DELETE_ABOUT_FAILURE = 'DELETE_ABOUT_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/AboutList/actionTypes.js